import React from 'react';
import { Select, type SelectProps } from 'antd';
import { buildStatusSelectionOptions } from '../statusSelection';

interface OrderStatusTransitionSelectProps extends Omit<SelectProps<string>, 'options'> {
  statuses: readonly string[];
  currentStatus: string;
  allowedTransitions: readonly string[];
  getStatusLabel: (status: string) => string;
  currentLabel: string;
  unavailableLabel: string;
}

const OrderStatusTransitionSelect: React.FC<OrderStatusTransitionSelectProps> = ({
  statuses,
  currentStatus,
  allowedTransitions,
  getStatusLabel,
  currentLabel,
  unavailableLabel,
  disabled,
  ...selectProps
}) => (
  <Select
    {...selectProps}
    disabled={disabled}
    options={buildStatusSelectionOptions(statuses, currentStatus, allowedTransitions).map((option) => ({
      value: option.status,
      disabled: option.disabled,
      label: (
        <span>
          {getStatusLabel(option.status)}
          {option.reason && (
            <span style={{ marginLeft: 8, color: '#94a3b8', fontSize: 12 }}>
              — {option.reason === 'current' ? currentLabel : unavailableLabel}
            </span>
          )}
        </span>
      ),
    }))}
  />
);

export default OrderStatusTransitionSelect;
